import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=158f3986&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=158f3986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f3986",
  null
  
)

export default component.exports